import { useParams } from 'react-router-dom';

/**
 * Hook to get the current services provider ID from the route parameters.
 *
 * The services provider ID represents the account/context the user is currently viewing.
 * It is derived from the URL route parameter and validated by AuthorizationGuard.
 *
 * @returns The current services provider ID from the route, or null if not in a SP route
 */
export function useCurrentServicesProviderId(): string {
	const params = useParams<{ servicesProviderId: string }>();
	return params.servicesProviderId || 'not-found';
}
